import { render, staticRenderFns } from "./no-ssr-loader.vue?vue&type=template&id=0af7c285&scoped=true"
import script from "./no-ssr-loader.vue?vue&type=script&lang=js"
export * from "./no-ssr-loader.vue?vue&type=script&lang=js"
import style0 from "./no-ssr-loader.vue?vue&type=style&index=0&id=0af7c285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7c285",
  null
  
)

export default component.exports